import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { StorageService } from './storage.service';
import { throwError } from 'rxjs';
import { PlanGestionConvivenciaModel } from '../model/PlanGestionConvivencia.model';

const getActaJardinTutorPlanMejora = 'planGestionConvivencia/';
const savePlanGestionConvivencia = 'planGestionConvivencia/';
const sendPlanGestionConvivencia = 'planGestionConvivencia/enviar/';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
};  
const httpOptionsFile = {

  headers: new HttpHeaders({    
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
}; 
@Injectable({
  providedIn: 'root'
})
export class PlanGestionConvivenciaService {


  constructor(private http:HttpClient,private storageService: StorageService) { }

  API_GET_getPlanGestionConvivencia(idJardinPeriodo: number) {
    return this.http.get(environment.apiEndpoint + getActaJardinTutorPlanMejora + idJardinPeriodo, httpOptions).pipe(
      catchError(this.handleError)
    );
  }


  API_POST_savePlanGestionConvivencia(idJardinPeriodo: number, pgc:PlanGestionConvivenciaModel) {
    return this.http.post(environment.apiEndpoint + savePlanGestionConvivencia + idJardinPeriodo, pgc, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_PUT_enviarPlanGestionConvivencia(idJardinPeriodo: number, pgc: PlanGestionConvivenciaModel) {
    return this.http.post(environment.apiEndpoint + sendPlanGestionConvivencia + idJardinPeriodo, pgc, httpOptions).pipe(
      catchError(this.handleError)
    );
  }


  handleError(error) {    
    let errorMessage = '';
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.message}`;
    return throwError(errorMessage);
  }

}
